'use strict'
import {Splide} from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

if (document.getElementById('brands')) {
    let brands = new Splide('#brands', {
        type: 'loop',
        drag: 'free',
        // Если ставить perPage = 3 то при перемотке иногда дёргаться начинает.
        // Число 9 эмпирически подобрано (на данный момент имено столько было элементов в списке).
        perPage: 9,
        pagination: false,
        arrows: false,
        autoScroll: {
            speed: .5,            // Скорость прокрутки (1 - медленно, 0.1 - очень медленно)
            pauseOnHover: true,  // Останавливает прокрутку при наведении мыши
            pauseOnFocus: false, // Останавливает прокрутку при фокусе на элементах слайдера
            rewind: false        // Не возвращается в начало после остановки (если drag: 'free')
        },
    });
    brands.mount({AutoScroll});
}